module.exports = function() {
  return new Worker("/" + "assets/download.worker.57a7d78f09d79574ec24.js");
};